import { Container } from 'src/components/Container/Container'
import { Image } from 'src/components/Image/Image'
import { config } from 'src/config'

import styles from './Gallery.module.scss'

import type { GalleryGridModule } from 'src/types/Module'

export const Gallery = ({ images = [], layout }: GalleryGridModule) => {
  const cssClasses: string[] = []

  ;(layout || '3232').split('').forEach((imagesPerRow) => {
    for (let i = Number(imagesPerRow); i > 0; i -= 1) {
      switch (imagesPerRow) {
        case '1':
          cssClasses.push(styles.single)
          break
        case '2':
          cssClasses.push(styles.double)
          break
        case '3':
          cssClasses.push(styles.triple)
          break
        case '4':
          cssClasses.push(styles.quadruple)
          break
        default:
          cssClasses.push(styles.quadruple)
      }
    }
  })

  return (
    <Container className={styles.gallery}>
      {images.map(({ id, filename, alt, title, width, height }, i) => (
        <div className={cssClasses[i]} key={id}>
          <Image
            identifier={id}
            filename={filename}
            alt={alt}
            title={title}
            srcSet={[400, 800]}
            sizes={`(min-width: ${config.breakpoints.lg}px) 400px, 200px`} // low resolution image on mobile for SEO
            width={`${width}`}
            height={`${height}`}
            responsive
            lazy
          />
        </div>
      ))}
    </Container>
  )
}
